









import Vue from 'vue'
import { mapState } from 'vuex'

import SuspectedChart from '@/components/Card/History/SuspectedChart.vue'
import { IStateThing } from '@/store/modules/thing'

export default Vue.extend({
  data() {
    return {
      loading: false
    }
  },
  components: {
    SuspectedChart
  },
  methods: {
    getHistory() {
      const hasSerial = this.$store.state.thing.serial
      if (!hasSerial) return

      this.loading = true
      this.$store.dispatch('history/getMotionEvents').finally(() => {
        this.loading = false
      })
    }
  },
  computed: {
    ...mapState<IStateThing>('thing', {
      serial: (state: IStateThing) => state.serial
    })
  },
  watch: {
    serial: function() {
      this.$store.commit('history/resetMotionHistory')
      this.getHistory()
    }
  },
  mounted() {
    this.getHistory()
  },
  beforeDestroy() {
    this.$store.commit('history/resetMotionHistory')
  }
})
